import { centerable as n } from "../decorators/centerable.js";
import { uploadable as d } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as l, ALIGN_CLASSES as o } from "../../constants.js";
import { defineAttrs as u } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const c = u({
  type: { default: "image" },
  src: { default: "" },
  linkUrl: { default: "" },
  width: { default: "" },
  displayWidth: { default: "" },
  height: { default: "" },
  text: { default: "" }
}), A = n(
  d({
    inline: !1,
    draggable: !0,
    attrs: c,
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-image",
        priority: 60,
        getAttrs(t) {
          const e = t.querySelector("img");
          if (!e)
            throw new Error("img not found");
          return {
            src: e.getAttribute("src") ?? "",
            text: e.getAttribute("alt") ?? ""
          };
        }
      },
      {
        tag: "img[src]",
        getAttrs(t) {
          return {
            src: t.getAttribute("src") ?? "",
            linkUrl: t.getAttribute("data-link-url") ?? "",
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            width: t.getAttribute("data-width") || t.style.width.replace("px", ""),
            height: t.getAttribute("data-height") ?? "",
            text: t.getAttribute("alt") ?? ""
          };
        }
      }
    ],
    toDOM(t) {
      const e = t.attrs, { src: s, width: i, height: g, text: a } = e;
      let { displayWidth: r } = e;
      return r = r || i, [
        "div",
        {
          class: `${l.blockContainer} ${l.image}`
        },
        [
          "img",
          {
            src: s,
            ...a && { alt: a },
            class: `${o[e.alignment] ?? ""}`,
            style: `display: block; width: ${r}px;`,
            "data-link-url": e.linkUrl,
            "data-height": g,
            "data-width": i
          }
        ]
      ];
    }
  })
);
export {
  A as imageSpec
};
